<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    @close="close"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="上级ID" prop="parentId">
        <!-- <el-input v-model="form.parentId"></el-input> -->
        <el-cascader
          v-model="form.parentIdPath"
          style="width: 100%"
          :options="tags"
          :props="{ expandTrigger: 'hover', value: 'id', label: 'name', checkStrictly: true }"
        ></el-cascader>
      </el-form-item>

      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item label="图标" prop="icon">
        <image-upload v-model="form.icon" />
        <!-- <el-input v-model="form.icon"></el-input> -->
      </el-form-item>

      <!-- <el-form-item label="type" prop="type">
        <el-input v-model="form.type"></el-input>
      </el-form-item> -->

      <el-form-item label="描述" prop="description">
        <el-input v-model="form.description"></el-input>
      </el-form-item>

      <el-form-item label="排序" prop="sortNo">
        <el-input v-model="form.sortNo"></el-input>
      </el-form-item>

      <!-- <el-form-item label="状态" prop="status">
        <el-input v-model="form.status"></el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
export default {
  components: { ImageUpload },
  data() {
    return {
      title: "",
      form: {},
      rules: {},
      dialogFormVisible: false,
      loading: false,

      tags: [],
    };
  },
  methods: {
    async showEdit(row) {
      await this.loadTags();
      if (!row) {
        this.title = "添加";
      } else {
        this.title = "编辑";
        this.form = await this.axios.get("base:/api/admin/tag/" + row.id);
        if (this.form.parentIdPath && this.form.parentIdPath.length) {
          this.form.parentIdPath = [0, ...this.form.parentIdPath];
        } else {
          this.form.parentIdPath = [0];
        }
      }
      this.$forceUpdate();
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs.formRef.resetFields();
      this.form = {};
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          let url;
          if (this.title === "添加") {
            url = "base:/api/admin/tag/create";
          } else if (this.title === "编辑") {
            url = "base:/api/admin/tag/update";
          }

          const params = {
            ...this.form,
          };
          if (this.form.parentIdPath && this.form.parentIdPath.length) {
            params.parentId = this.form.parentIdPath[this.form.parentIdPath.length - 1];
          }
          delete params.parentIdPath;

          // 固定为品牌标签
          params.type = 1;

          try {
            await this.axios.form(url, params);
            this.$message.success("保存成功");
            this.$emit("success");
            this.close();
          } catch (e) {
            this.$notify.error({ title: "错误", message: e.message || e });
          }
        }
      });
    },

    async loadTags() {
      const tags = await this.axios.get("/api/admin/tag/legit_check_tags");
      this.tags = [
        {
          id: 0,
          name: "顶级",
          children: tags,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
